import { useEffect, useCallback } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';

import './Toasty.css';
import { getPreschoolNotification } from '../../Redux/preschool/preschool';

const Toasty = ({ setShowNotification }) => {
  const notification = useSelector(getPreschoolNotification);

  const handleToastClose = useCallback(() => {
    setShowNotification(false);
  }, [setShowNotification]);

  const NotificationInformation = () => (
    <div className="notification_information_container">
      <img src={notification?.url} alt="notification" />
      <div className="notification_container">
        <h6 className="mues_grey_I mues_font_weight_600">
          {notification?.title}
        </h6>
        <label className="mues_grey_I mues_font_weight_400">
          {notification?.body}
        </label>
      </div>
    </div>
  );

  useEffect(() => {
    toast(<NotificationInformation />, {
      onClose: handleToastClose,
      className: "toast_container",
    });
  }, [handleToastClose]); // Include handleToastClose in dependencies

  return (
    <div className="toasty">
      <ToastContainer className="toast_container" />
    </div>
  );
};

export default Toasty;
